import { useEffect, useRef } from 'react';

// New contacts are persisted on arrival. Refresh on return, with a five-minute fallback.
// Only visible lists refresh; never overlap requests or reset a draft/selection.
export default function useAutoRefresh(refresh, paused = false, intervalMs = 5 * 60 * 1000) {
  const running = useRef(false);
  useEffect(() => {
    const update = async () => {
      if (paused || document.visibilityState === 'hidden' || running.current) return;
      running.current = true;
      try {
        await refresh({ background: true });
      } finally {
        running.current = false;
      }
    };
    const timer = setInterval(update, intervalMs);
    window.addEventListener('focus', update);
    document.addEventListener('visibilitychange', update);
    return () => {
      clearInterval(timer);
      window.removeEventListener('focus', update);
      document.removeEventListener('visibilitychange', update);
    };
  }, [refresh, paused, intervalMs]);
}
